/**
 * Created by christiancueni on 03/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import { UserActionTypes } from '../actions/users';
import { User, SchoolRole } from '../models';
import { CustomAction } from '../actions/CustomAction';

export interface UsersState {
    users: User[];
    roles: SchoolRole[];
    user: User;
    loading: boolean;
    showDeleteUsersModal: boolean;
    userFormErrors: Object[];
    importInfo: {
        createdRoles: string[],
        importErrors: string[]
    };
    showDeleteProfileModal: boolean;
}

export const initialUsersState: UsersState = {
    users: [],
    roles: [],
    user: null,
    loading: false,
    showDeleteUsersModal: false,
    userFormErrors: [],
    importInfo: {
        createdRoles: [],
        importErrors: []
    },
    showDeleteProfileModal: false
};

export function reducer(state = initialUsersState, action: CustomAction): UsersState {
    switch (action.type) {
        case UserActionTypes.LOAD_USERS:
            return Object.assign({}, state, {
                loading: true,
            });

        case UserActionTypes.LOAD_USERS_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                users: action.payload,
            });

        case UserActionTypes.LOAD_USERS_FAIL:
            return Object.assign({}, state, {
                loading: false,
            });

        case UserActionTypes.LOAD_USER:
            return Object.assign({}, state, {
                loading: true,
                user: null
            });

        case UserActionTypes.LOAD_USER_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                user: action.payload,
            });

        case UserActionTypes.LOAD_USER_FAIL:
            return Object.assign({}, state, {
                loading: false,
            });

        case UserActionTypes.ADD_USER:
            return Object.assign({}, state, {
                loading: true,
            });

        case UserActionTypes.ADD_USER_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                users: [
                    ...state.users,
                    action.payload
                ],
            });

        case UserActionTypes.ADD_USER_FAIL:
            return Object.assign({}, state, {
                loading: false,
            });

        case UserActionTypes.UPDATE_USER:
            return Object.assign({}, state, {
                loading: true,
            });

        case UserActionTypes.UPDATE_USER_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
            });

        case UserActionTypes.UPDATE_USER_FAIL:
            return Object.assign({}, state, {
                loading: false,
            });

        case UserActionTypes.SET_USER:
            return Object.assign({}, state, {
                user: action.payload,
            });

        case UserActionTypes.UNSET_USER:
            return Object.assign({}, state, {
                user: null
            });

        case UserActionTypes.DELETE_USERS_USER_ACTION:
        case UserActionTypes.DELETE_USER_USER_ACTION:
            return Object.assign({}, state, {
                showDeleteUsersModal: true
            });

        case UserActionTypes.DELETE_USERS_CONFIRMATION:
        case UserActionTypes.DELETE_USERS_CANCEL:
        case UserActionTypes.DELETE_USER_CONFIRMATION:
        case UserActionTypes.DELETE_USER_CANCEL:
            return Object.assign({}, state, {
                showDeleteUsersModal: false
            });

        case UserActionTypes.USER_FORM_ERRORS:
            return Object.assign({}, state, {
               userFormErrors: action.payload
            });

        case UserActionTypes.IMPORT_USERS_INFO:
            return Object.assign({}, state, {
               importInfo: action.payload
            });

        case UserActionTypes.IMPORT_USERS_RESET_INFO:
            return Object.assign({}, state, {
                importInfo: initialUsersState.importInfo
            });

        case UserActionTypes.RESET_USERS:
            return Object.assign({}, initialUsersState);

        case UserActionTypes.SHOW_DELETE_PROFILE_MODAL:
            return Object.assign({}, state, {
                showDeleteProfileModal: true
            });

        case UserActionTypes.HIDE_DELETE_PROFILE_MODAL:
            return Object.assign({}, state, {
                showDeleteProfileModal: false
            })

        default: {
            return state;
        }
    }
}


export const isLoading = (state: UsersState) => state.loading;

export function getUser(state: UsersState) {
    return state.user;
}

export function getUsers(state: UsersState) {
    return state.users;
}

export function getRoles(state: UsersState) {
    return state.roles;
}

export function getShowDeleteUsersModal(state: UsersState) {
    return state.showDeleteUsersModal;
}

export function getUserFormErrors(state: UsersState) {
    return state.userFormErrors;
}

export function getImportInfo(state: UsersState) {
    return state.importInfo;
}

export function showDeleteProfileModal(state: UsersState) {
    return state.showDeleteProfileModal;
}
